const breakPoints = {
  first: '1400px',
  second: '1160px',
  third: '880px',
  fourth: '660px',
  fifth: '590px',
  sixth: '320px',
}

export default breakPoints
